import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter un compte client")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "compteForm",
        onSubmit: _ctx.addCompte,
        "validation-schema": _ctx.compteSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Date de création "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateCreation",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "dateCreation",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Client "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "client" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.clientOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "client",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Solde initial "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "soldeInitial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le solde initial"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "soldeInitial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type de compte "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "typeCompte",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: _ctx.optionsCompte,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le type de compte" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "typeCompte",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[5] || (_cache[5] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Créer un compte ", -1)),
                _createVNode(_component_router_link, {
                  to: "/comptes/liste-comptes",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}